import { type ProductizedServiceExampleProject_portfolioProject$key } from '#app/__generated__/relay/ProductizedServiceExampleProject_portfolioProject.graphql.js';
import { Link } from '#app/components/Link/index.js';
import { Text } from '#app/components/Primitives/Text.js';
import { ProjectCoverWrapper } from '#app/components/ProjectCover/ProjectCoverWrapper.js';
import { graphql, useFragment } from '@contra/relay';
import { getRoute } from '@contra/routes';
import { css, styled } from 'styled-components';

const Container = styled.div`
  ${({ theme }) => css`
    width: 262px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 16px 32px 16px;
    background: ${theme.colorsV2.white};
    border: 1px solid ${theme.colorsV2.gray30};
    border-radius: 12px;
  `}
`;

const Title = styled(Text)`
  height: 54px;
  overflow: hidden;
`;

type ProductizedServiceExampleProjectsProps = {
  readonly portfolioProjectRef: ProductizedServiceExampleProject_portfolioProject$key;
};

export const ProductizedServiceExampleProject = ({
  portfolioProjectRef,
}: ProductizedServiceExampleProjectsProps) => {
  const { cover, slug, title } =
    useFragment<ProductizedServiceExampleProject_portfolioProject$key>(
      graphql`
        fragment ProductizedServiceExampleProject_portfolioProject on PortfolioProject {
          cover {
            ...ProjectCoverWrapper_portfolioProjectCover
          }
          slug
          title
        }
      `,
      portfolioProjectRef,
    );

  return (
    <Link
      to={getRoute('/p/@slug', {
        args: {
          slug,
        },
      })}
    >
      <Container>
        <ProjectCoverWrapper
          coverRef={cover}
          width={262}
        />
        <Title textStyle="sixthLevelHeadline">{title}</Title>
      </Container>
    </Link>
  );
};
